import ApiService from "@/services/Api"
import { BoardStageCard } from "@/services/BoardStageCardService"

export type BoardStageProperty = {
	type: "status"
	value: "won" | "lost"
}

export type BoardStage = {
	id: number
	name: string
	stageOrder: number
	boardId: number
	property?: BoardStageProperty
	cards: Array<BoardStageCard>
	createdAt: Date
	updatedAt: Date
}

export type BoardStageWithoutCards = {
	id: number
	name: string
	stageOrder: number
	boardId: number
	property?: BoardStageProperty
}

export type GetBoardStagesResponse = {
	stages: Array<BoardStage>
}

export type ClientInCard = {
	clientId: number
	clientInCardId: number
	cardId: number
	name?: string
	nickname: string
	phone: string
	email?: string
	pictureUrl?: string
}

export type BoardStageCard = {
	id: number
	responsibleUserId: number
	stageId: number
	boardId: number
	name: string
	cardOrder: number
	clients: Array<ClientInCard>
}

class BoardStageService {
	async getBoardStagesByBoardId (boardId: number): Promise<BoardStage[]> {
		const response = await ApiService.get<GetBoardStagesResponse>(`/boards/${boardId}/stages`)

		return response.data.stages
	}
}

export default new BoardStageService()
